// extracted by mini-css-extract-plugin
export default {"root":"wozw_t","line":"UjMU2O"};